import React from 'react';
import { Label, InputContainer } from './index';

interface ModalInput {
  Component: React.ComponentType<Record<string, unknown>>;
  id: string | number;
  [key: string]: unknown;
}

interface ModalInputSectionProps {
  customBottomMargin?: string;
  sectionTitle?: React.ReactNode;
  inputs: ModalInput[];
  children?: React.ReactNode;
}

const ModalInputSection = (props: ModalInputSectionProps): React.JSX.Element => (
  <InputContainer customBottomMargin={props.customBottomMargin}>
    {props.sectionTitle && <Label>{props.sectionTitle}</Label>}
    {props.inputs.map((input) => {
      const { Component, id, ...rest } = input;

      return <Component {...rest} key={id} />;
    })}
    {props.children}
  </InputContainer>
);

export default ModalInputSection;
